import React, { Component } from 'react';
import './Header.scss'
import video1 from "../Home/MoshiWaves.mp4";

class Header extends Component {

	state = {
		opacity: 1,
	}

	componentDidMount() {
		window.addEventListener('scroll', this.scrollEvents);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.scrollEvents);
	}

	scrollEvents = async (e) => {
		let opacity = 1 - (window.scrollY / (1024 / 1));
		if (opacity > 1) {
			opacity = 1
		}
		this.setState({ opacity })
	}

	scrollToFooter = async () => {
		let footer = document.getElementById("footer");
		footer.scrollIntoView({
			behavior: 'smooth'
		});
	}
	
	render() {
		return (
			
			<header className="header" style={{ opacity: this.state.opacity }}>
				<div className="header-overlay"></div>
				<video autoPlay="true" muted loop id="headerVideo">
					<source src={video1} type="video/mp4"/>
				</video>
				<div className="container-fluid">
					<div className="row align-items-center">
						<div className="col-lg-4 text-center">
							<img
								onClick={this.scrollToFooter}
								className="header-circle"
								src={require('./circle-1.png')} alt="Check Out Our Recent Work"
							/>
						</div>
						<div className="col-lg-8">
							<h1 className="cart">
								<a href="#scroll-to-section-4">marketing</a>
								<div><a class="middle-header-link" href="#scroll-to-section-1">graphic design</a></div>
								<a href="#scroll-to-section-3">web/app development</a>
							</h1>
						</div>
					</div>
				</div>

			</header>
		);
	}
}

export default Header;


// WEBPACK FOOTER //
// ./src/Pages/Home/Header.js